import React from 'react'
import styled from 'styled-components'
import { line, radius, font, surface } from 'features/dashboard/tokens'
import { scoreColour } from 'features/dashboard/charts/scoreColour'

const pct = v => (v === null || v === undefined ? 'No score' : `${Math.round(v)}%`)

const TaskCompletionCard = ({ tasks = {}, period = 'all', rangeLabel }) => {
  const onTimeRate = tasks.onTimeRate
  const periodLabel = rangeLabel || (period === 'month' ? 'this month'
    : period === 'quarter' ? 'this quarter'
      : period === 'year' ? 'this year'
        : 'all time')

  const cells = [
    { key: 'onTime', value: tasks.completedOnTime ?? 0, label: 'On time', tint: '#15803d' },
    { key: 'late', value: tasks.completedLate ?? 0, label: 'Late', tint: '#d97706' },
    { key: 'overdue', value: tasks.overdue ?? 0, label: 'Overdue', tint: '#b00020' },
    { key: 'completion', value: pct(tasks.completionRate), label: 'Completion', tint: '#2aa6b3' },
  ]

  return (
    <Wrap>
      <Big $tint={scoreColour(onTimeRate)} title='On-time rate. Of the tasks completed, the share finished on or before the deadline.'>
        <BigValue>{pct(onTimeRate)}</BigValue>
        <BigLabel>on-time completion · {periodLabel}</BigLabel>
      </Big>
      <Grid>
        {cells.map(c => (
          <Cell key={c.key} $tint={c.tint}>
            <CellValue>{c.value}</CellValue>
            <CellLabel>{c.label}</CellLabel>
          </Cell>
        ))}
      </Grid>
    </Wrap>
  )
}

export default TaskCompletionCard

const Wrap = styled.div`
  display: flex; flex-direction: column; gap: 12px;
`

const Big = styled.div`
  display: flex; flex-direction: column; align-items: center; gap: 2px;
  padding: 14px;
  border-radius: ${radius.md};
  background: ${({ $tint }) => `${$tint}12`};
  border: 1px solid ${({ $tint }) => `${$tint}33`};
`

const BigValue = styled.span`
  font-family: 'FuturaPT-Light', system-ui, sans-serif;
  font-size: ${font.display};
  letter-spacing: -0.6px;
  color: ${({ theme }) => theme.colors.haiti};
  line-height: 1;
`

const BigLabel = styled.span`
  font-size: ${font.caption};
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grey[800]};
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`

const Cell = styled.div`
  display: flex; flex-direction: column; align-items: center; gap: 2px;
  padding: 8px;
  border-radius: ${radius.sm};
  background: ${surface.wash};
  border: 1px solid ${line.base};
  border-left: 3px solid ${({ $tint }) => $tint};
`

const CellValue = styled.span`
  font-family: 'FuturaPT-Light', system-ui, sans-serif;
  font-size: ${font.title};
  letter-spacing: -0.4px;
  color: ${({ theme }) => theme.colors.haiti};
  line-height: 1;
  font-variant-numeric: tabular-nums;
`

const CellLabel = styled.span`
  font-size: ${font.caption};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.grey[800]};
`
